import request from '@/utils/request'

let Car_numberApi = {

  /*车牌列表*/
  list(data) {
    return request._post('/shop/plus.car_number.Index/index', data);
},
/*添加车牌*/
add(data) {
    return request._post('/shop/plus.car_number.Index/add', data);
},
/*修改车牌*/
edit(data) {
    return request._post('/shop/plus.car_number.Index/edit', data);
},
/*删除车牌*/
del(data) {
    return request._post('/shop/plus.car_number.Index/del', data);
},
/*车牌详情*/
detail(data) {
  return request._post('/shop/plus.car_number.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.car_number.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.car_number.Setting/getSetting', data, errorback);
    },
}
export default Car_numberApi;



// WEBPACK FOOTER //
// ./src/api/car_number.js